export default __webpack_public_path__ + "9b674e1f095bc1fcbc1771a695da0c0e.png";